import { useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import ApiAgent from "../../../core/api/api.agent";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import { numberRegex } from "../../../core/utils/tools";

const EditUserNameModal = ({ setShowModalEditUserName, selectedUser }) => {
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
  } = useForm({});
  const handleClose = () => {
    setShowModalEditUserName(false);
  };
  useEffect(() => {
    (async () => {
      try {
        if (selectedUser != 0) {
          // دریافت اطلاعات کاربر جهت ویرایش
          let response = await ApiAgent.getAgentUserById({ id: selectedUser });
          if (response.succeeded == true) {
            setValue("id", response.data.id);
            setValue("phoneNumber", response.data.phoneNumber);
            setValue("userName", response.data.userName);
            setValue("firstName", response.data.firstName);
            setValue("lastName", response.data.lastName);
            setValue("companyName", response.data.companyName);
          } else {
            SwalMessage({ title: response.message, iSsuccess: response.succeeded });
            return;
          }
        }
      } catch (error) {
      }
    })();

    return () => { };
  }, []);

  const onSubmit = async (data) => {
    try {
      data.agentId = selectedUser;
      let response = await ApiAgent.updateAgentUser(data);
      if (response.succeeded == true) {
        document.getElementById("submitButton").click();
        setShowModalEditUserName(false);
      }

      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="md" show={setShowModalEditUserName} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>ویرایش اطلاعات نماینده</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col xs="12">
              <Row>
                <Col xs="12">
                  <Controller
                    name="firstName"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="lastName"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام خانوادگی"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="companyName"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام شرکت"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="userName"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام کاربری"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors.userName && <span className="text-danger text-small">لطفا نام کاربری را وارد نمایید</span>}
                </Col>
                <Col xs="12">
                  <Controller
                    name="phoneNumber"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="شماره تلفن همراه"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={(e) => {
                          if (e.target.value && (!numberRegex.test(e.target.value) || e.target.value.length > 11)) {
                            e.target.value = getValues("phoneNumber")
                            return
                          }
                          onChange(e)
                        }}
                      />
                    )}
                  />
                  {errors.phoneNumber && (
                    <span className="text-danger text-small">لطفا شماره موبایل را وارد نمایید</span>
                  )}
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
export default EditUserNameModal;
